import { useState, useEffect } from "react";
import styles from "./Gallery.module.css";

export default function Gallery({ ballroom  }) {
  const images = ballroom?.images || [];

  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    if (images.length > 0) {
      const cover =
        images.find((img) => img.is_cover)?.image || images[0].image;

      setSelectedImage(cover);
    }
  }, [images]);

  if (!ballroom || images.length === 0) {
    return null;
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Ballroom Gallery</h2>

        <div className={styles.preview}>
          <img
            src={selectedImage}
            alt="Ballroom"
            className={styles.mainImage}
          />
        </div>

        <div className={styles.thumbnailGrid}>
          {images.map((img) => (
            <img
              key={img.id}
              src={img.image}
              alt="Thumbnail"
              className={`${styles.thumbnail} ${
                selectedImage === img.image ? styles.active : ""
              }`}
              onClick={() => setSelectedImage(img.image)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}